import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';
import {useMultiStyleConfig} from '@chakra-ui/system';

const parts = [`dialog`, `header`, `body`] as const;
export type ModalParts = (typeof parts)[number];

const helper = createMultiStyleConfigHelpers(parts);

const drawerStyleConfig = helper.defineMultiStyleConfig({
  baseStyle: {
    dialog: defineStyle({
      p: `space-300`,
      backgroundColor: `background.primary`,
    }),
    header: {
      // TODO(PRE-314): transform typography tokens
      fontSize: `lg`,
      fontWeight: `medium`,
      lineHeight: `shorter`,
    },
  },
});

const DrawerTheme = {...drawerStyleConfig};

export default DrawerTheme;

export const useDrawerStyleConfig = (part: ModalParts, props?: Parameters<typeof useMultiStyleConfig>[1]) => {
  return useMultiStyleConfig(`Drawer.${part}`, props ?? {});
};
